export default __webpack_public_path__ + "static/media/453.7fb2a21d.png";